export default __webpack_public_path__ + "static/media/ecofriendly.8afe7d85.svg";